import { memo } from "react";
import { Routes as RoutesWrapper, Route } from "react-router-dom";
import '../style.css';
import { Users, Roles, ChangePassword, ServiceTypes, ServiceCategories, HomePage, ProvidersRR, ProvidersRRDetails, UsersRequests, ProviderProfile, MedicalRequestDetails } from "@pages/Exporter";

const AuthedRoutes = () => {



  return (
    <RoutesWrapper>
      <Route path="panel/*" element={
        <RoutesWrapper>
          <Route path="/" element={<HomePage />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="service-types" element={<ServiceTypes />} />
          <Route path="service-category" element={<ServiceCategories />} />
          <Route path="providers-request" element={<ProvidersRR />} />
          <Route path="request-details/:id" element={<ProvidersRRDetails />} />
          <Route path="medical-users-requests" element={<UsersRequests />} />
          <Route path="medical-request-details/:id" element={<MedicalRequestDetails />} />
          <Route path="provider-profile" element={<ProviderProfile />} />
        </RoutesWrapper>
      } />
    </RoutesWrapper>
  );
};

export default memo(AuthedRoutes);